module.exports = __webpack_public_path__ + "img/15-1_Sigmoid.7db312c7.png";